// removed by extract-text-webpack-plugin
module.exports = {"overlay":"style__overlay___62b3s","overlayModal":"style__overlayModal___2dslD","overlayModalInner":"style__overlayModalInner___3DnKp","overlayCloseButton":"style__overlayCloseButton___1KGhn","overlayModalTitle":"style__overlayModalTitle___2jmL1","overlayModalText":"style__overlayModalText___13NX5","overlayModalTextBold":"style__overlayModalTextBold___2eT-Q","overlayModalButtons":"style__overlayModalButtons___3Cc7T","overlayModalButtonsItem":"style__overlayModalButtonsItem___2kMy4","overlayModalButtonsItemButton":"style__overlayModalButtonsItemButton___2gk0R","buttonActive":"style__buttonActive___1kpyk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-currency/style.css
// module id = 1132
// module chunks = 0